import { validateTfn } from '../../../../common/utils';

export const yupValidateTfn = (value: string | null | undefined): boolean => {
  const rawValue = (value || '').replace(/[\s-_]/g, '');
  const tfnMask = '*********';

  if (rawValue === tfnMask) return true;

  if (!!rawValue) {
    return validateTfn(rawValue);
  }
  return true;
};
